const handleAuthErrors = (errCode: string) => {
  if (errCode === 'auth/user-not-found') {
    return "we couldn't find your account";
  } else if (errCode === 'auth/wrong-password') {
    return 'incorrect password';
  } else return 'something went wrong';
};

export default handleAuthErrors;
